import { memo } from 'react';
import { Typography } from '@pocketlaw/tetris';
import useSetAsRead from 'shared/domains/feedback/hooks/useSetAsRead';
import { Container, MessageBubble, MessageNotification, StyledText } from './styled';
function MessageContainer(props) {
    const { message, hideSender, hideTimestamp } = props;
    const { id, type, message: text, sender, createdAt, isRead } = message;
    const { name } = sender;
    useSetAsRead(message);
    const showNotification = type === 'receiver' && !isRead;
    const incomingMessage = type === 'receiver';
    return (<Container key={id} $incoming={incomingMessage} $hideTimestamp={hideTimestamp}>
      {!hideSender && (<StyledText $incoming={incomingMessage} $fontSize="small" $fontWeight="semibold">
          {name}
        </StyledText>)}
      {!hideTimestamp && (<Typography $lineHeight="neutralized" $fontSize="tiny">
          {createdAt}
        </Typography>)}
      <MessageBubble $incoming={incomingMessage}>
        <Typography $lineHeight="neutralized" $fontSize="small">
          {text}
        </Typography>
        {showNotification && <MessageNotification />}
      </MessageBubble>
    </Container>);
}
export const Message = memo(MessageContainer, (prev, next) => prev.message.id === next.message.id);
